<ng-container *ngIf="block.url || block.entry; else noLink">
    <a [href]="block.entry ? block.entry : (block.url ? block.url : safeURL)"
       class="h-full no-underline"
       [ngClass]="{'cursor-auto': !(block.entry ? block.entry : (block.url ? block.url : false))}">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
</ng-container>

<ng-template #noLink>
    <div class="h-full" [ngClass]="{'cursor-auto': !(block.entry ? block.entry : (block.url ? block.url : false))}">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
</ng-template>

<ng-template #content>
    <div class="p-5 h-full bg-endeavour-green shadow-2 border-round-xl flex flex-col">
        <div class="flex align-items-center mb-2">
            <app-icon [icon]="block.icon.value" class="mr-3 text-brand-color"></app-icon>
        </div>

        <app-wysiwyg [theme]="theme" [block]="blockWithoutButtons"
                     class="break-words line-height-3 text-lg mb-2 flex-1"
                     blockClass="[&_*]:!text-white"></app-wysiwyg>

        <ng-container *ngIf="buttons.length > 0; else moreInfo">
            <app-button *ngFor="let button of buttons" [block]="button" [theme]="theme"></app-button>
        </ng-container>

        <ng-template #moreInfo>
            <span class="text-sm text-white">Meer info <i class="pi pi-arrow-right"></i></span>
        </ng-template>
    </div>
</ng-template>
